const TURKISH_MONTHS = [
    'OCAK',
    'ŞUBAT',
    'MART',
    'NİSAN',
    'MAYIS',
    'HAZİRAN',
    'TEMMUZ',
    'AĞUSTOS',
    'EYLÜL',
    'EKİM',
    'KASIM',
    'ARALIK',
] as const;

export const STUDIO_WAREHOUSE_CODE = 'StudioWareHouse';

export function getStudioUploadUsername(): string {
    try {
        const checkOperator = JSON.parse(localStorage.getItem('checkOperator') || '{}');
        if (checkOperator?.username) {
            return String(checkOperator.username).toLocaleUpperCase('tr-TR');
        }
    } catch {
        // ignore
    }
    return 'SYSTEM';
}

/** {env}/{root}/{year}ÇEKİMLER/{MM}_{AY}/{dd}.{MM}.{yyyy}/{username}/ */
export function buildStudioShotUploadPrefix(rootSegment: string, date: Date = new Date()): string {
    const envPref = String(import.meta.env.VITE_ENVIRONMENT ?? '')
        .trim()
        .replace(/\/+$/, '');
    const normalizedRoot = rootSegment.replace(/^\/+|\/+$/g, '');
    const base = envPref ? `${envPref}/${normalizedRoot}/` : `${normalizedRoot}/`;

    const year = date.getFullYear();
    const monthNum = String(date.getMonth() + 1).padStart(2, '0');
    const monthName = TURKISH_MONTHS[date.getMonth()];
    const monthFolder = `${monthNum}_${monthName}`;

    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${day}.${monthNum}.${year}`;
    const yearFolder = `${year}ÇEKİMLER`;
    const username = getStudioUploadUsername();

    return `${base}${yearFolder}/${monthFolder}/${dateStr}/${username}/`;
}

/** Toplu ham görsel yükleme — siteye_yuklenecekler ile aynı klasör mantığı, kök: rawimages */
export function buildRawImagesUploadPrefix(date: Date = new Date()): string {
    return buildStudioShotUploadPrefix('rawimages', date);
}

export function buildStudioS3ObjectKey(folderPrefix: string, fileName: string): string {
    if (!folderPrefix) {
        return fileName;
    }
    const cleanPrefix = folderPrefix.endsWith('/') ? folderPrefix.slice(0, -1) : folderPrefix;
    return `${cleanPrefix}/${fileName}`;
}

/**
 * {ENV}/path → {ENV}/.thumbnail/path (StudioBackend TempImageS3Service ile aynı kural).
 * Zaten /.thumbnail/ içeriyorsa veya tek segment ise orijinal key döner.
 */
export function toTempS3Key(sourceKey: string): string {
    const key = String(sourceKey ?? '')
        .replace(/\\/g, '/')
        .trim()
        .replace(/^\/+/, '');
    if (!key) {
        return key;
    }
    const lower = key.toLowerCase();
    if (lower.includes('/.thumbnail/') || lower.startsWith('.thumbnail/')) {
        return key;
    }
    const slashIndex = key.indexOf('/');
    if (slashIndex <= 0 || slashIndex >= key.length - 1) {
        return key;
    }
    return `${key.slice(0, slashIndex)}/.thumbnail/${key.slice(slashIndex + 1)}`;
}

/**
 * Orijinal S3 key'inden thumbnail key üretir:
 * {ENV}/rawimages/... → {ENV}/.thumbnail/rawimages/...
 */
export function toThumbnailS3Key(sourceKey?: string): string {
    return toTempS3Key(sourceKey ?? '');
}
